import { render, staticRenderFns } from "./AXfooter.vue?vue&type=template&id=184893f8&scoped=true&"
import script from "./AXfooter.vue?vue&type=script&lang=js&"
export * from "./AXfooter.vue?vue&type=script&lang=js&"
import style0 from "./AXfooter.vue?vue&type=style&index=0&id=184893f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184893f8",
  null
  
)

export default component.exports